export default __webpack_public_path__ + "dot-and-circle.png";